// extracted by mini-css-extract-plugin
export default {"notificationcircle":"ZerosRow_notificationcircle__NkGrV","zerosRow":"ZerosRow_zerosRow__OXlkT","zerosRowFont":"ZerosRow_zerosRowFont__U9jz9"};